import { render } from "./SelectColorModal.vue?vue&type=template&id=a8b0bf80&scoped=true"
import script from "./SelectColorModal.vue?vue&type=script&lang=js"
export * from "./SelectColorModal.vue?vue&type=script&lang=js"

import "./SelectColorModal.vue?vue&type=style&index=0&id=a8b0bf80&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b0bf80"]])

export default __exports__